exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box[data-v-3100ce2c]{\n    margin-right: 25%;\n    margin-left: 25%;\n    margin-top: 55px;\n    border: 3px solid #35495E;\n    border-radius: 20px;\n}\n.field[data-v-3100ce2c]{\n    padding:10px;\n    text-align:center;\n}\n.textlabel[data-v-3100ce2c]{\n    white-space:nowrap;\n    color:#35495E;\n}\n.textfield[data-v-3100ce2c]{\n\tmargin:16px;\n\tfont-size:24px;\n}\n.title[data-v-3100ce2c]{\n    font-size:30px;\n    font-weight:bold;\n    color:#35495E;\n}\ntable[data-v-3100ce2c] {\n    table-layout:auto;\n    margin:auto;\n    width:75%;\n    border: none;\n}\ntd[data-v-3100ce2c] {\n    border: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3100ce2c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/add/Scan_Inventory_Item.vue
// module id = 661
// module chunks = 0